import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, retry, timer } from 'rxjs';
import { Global } from '../global/globalApi';
import { TbaRegistrationDTO } from '../models/TbaRegistrationDTO';
import { NewAgentApiService } from './new-agent-api.service';
import { RootScopeService } from './root-scope.service';
import * as Constants from '../../app/models/Constants';
import { EncryptDecryptService } from './encrypt-decrypt.service';
import { AwsSqsService } from './aws-sqs.service';
import { LogService } from './log.service';


@Injectable({
  providedIn: 'root',
})
export class DashboardBusinessLogicService {
fileName: string = 'dashboardBusinessLogicService';

  constructor(
    private http: HttpClient,
    public awsSQSService: AwsSqsService,
    public rootScopeService: RootScopeService,
    private logService: LogService,
  ) { }

  setUtilityInterval:any;
  utilityError:boolean=false;
  isErrorMsgVisible:boolean=false;


  /* Below savePreferenceValue method save the preference value of pref_region in database */
  savePreferenceValue(): Observable<any> {
    let lanId: any = sessionStorage.getItem('lanId');
    let pref_region: any = sessionStorage.getItem('selectedRegion');
    let payload = {
      lan_id: lanId,
      pref_region: pref_region,
    };
    return this.http.post(
      Global.domainUrl + Global.dashboardApi.SAVE_PREFERENCE_VALUE,
      payload,
      {
        headers: this.rootScopeService.getCommonHeaders(Constants.apiVersions),
        responseType: 'text',
      }
    );
  }

  tbaGuiRegistration(reqBody: TbaRegistrationDTO): Observable<any> {
    // console.log('Method tbaGuiRegistration called');
    let url = Global.domainUrl + Global.TBA_GUI_REGISTER_API;
    // console.log('tbaGuiRegistration url', url);
    return this.http.post(url, reqBody, {
      headers: this.rootScopeService.getCommonHeaders(Constants.apiVersions),
      responseType: 'text',
    });
  }

  /**Below method fetch the TBA GUI WebFront and data contain the TBA GUI port number and also the
  * TBA GUI session and on the successful response we change the TBA indicator to green and start the
  * startTbaConnectivityInterval() method and in case of an error we change the TBA indicator to red .*/

  getTBAGUIWebFrontData() {
    this.logService.debugLogs("TBA registration initiated", this.fileName);
    const lanId: string = this.rootScopeService.lanId||sessionStorage.getItem('lanId');
    const payload = {
      username: lanId,
    };
    const url = `${Global.domainUrl}${Global.TBA_GUI_GET_DATA_API}`;
    return this.http
      .post(url, payload, {
        headers: this.rootScopeService.getCommonHeaders(Constants.apiVersions),
        responseType: 'text',
      }).pipe(retry({ count: 3, delay: 5000 }),)
      .subscribe({
        next: (res: any) => {
          const data = JSON.parse(res);
           /* istanbul ignore next */
          if (data && data?.data?.port) {
            sessionStorage.setItem('tba_port', data?.data?.port);
            sessionStorage.setItem('tba_sessionId', data?.data?.sessionId);
            this.logService.debugLogs("TBA registered, tba_port and tba_sessionId fetched successfully.", this.fileName);
            this.loginTBAGUIApp();
          
          // this.rootScopeService.tbaIndicatorClass.next(
          //   Constants.TBA_INDICATOR_COLOR.GREEN
          // );
          // this.rootScopeService.TBAGUIHealthCheckError = false;
          // this.rootScopeService.TBAGUIConnected = true;

          this.startTbaConnectivityInterval();         
          }
        },
        
        error: (err: any) => {
          /* istanbul ignore next */
          if (err) { 
            let objectError: any = {};
            if(err?.error){        
                 try {
                 objectError = JSON.parse(err?.error);
               } catch (e) {
                 objectError = err?.error;
               }
            }

            this.rootScopeService.tbaIndicatorClass.next(
              Constants.TBA_INDICATOR_COLOR.RED
            );           
            this.rootScopeService.TBAGUIHealthCheckError = true;
            this.rootScopeService.TBAGUIConnected = false;
            console.log('isLogEnabledUser---->' + this.rootScopeService.isLogEnabledUser);
            this.logService.errorLogs("TBA registration failed | Response Type - " + JSON.stringify(objectError), this.fileName);
          }
        },
      });
  }


  runTimeUtilityLogin(loginLanId) {    
   this.logService.debugLogs("Run Time Utility initiated for connection", this.fileName);
   /* istanbul ignore next */   
   setTimeout(() => {   
    const lanId: string = loginLanId ? loginLanId : sessionStorage.getItem('lanId');
    const payload = {
      username: lanId,
    };
    const url = `${Global.domainUrl}${Global.TBA_GUI_GET_DATA_API}`;
    return this.http
      .post(url, payload, {
        headers: this.rootScopeService.getCommonHeaders(Constants.apiVersions),
        responseType: 'text',
      }).pipe(retry({ count: 3, delay: 5000 }),)
      .subscribe({
        next: (res: any) => {      
          const data = JSON.parse(res);               
          if (data && data?.data?.port) {
            sessionStorage.setItem('tba_port', data?.data?.port);
            sessionStorage.setItem('tba_sessionId', data?.data?.sessionId);
            this.logService.debugLogs("Run Time Utility connected, tba_port and tba_sessionId fetched successfully", this.fileName);
            this.utilityError = false;
            this.getUtilityHealth();
            const intervalTime = 2 * this.rootScopeService.UtiltyConnectivityThreshold;
            this.setUtilityInterval = setInterval(() => {
              this.getUtilityHealth();
            }, intervalTime);
          }
        },        
        error: (err: any) => {
          if (err?.error) {
            let objectError = {};
            try{
             objectError = JSON.parse(err?.error);
            }
            catch(e){
               objectError = err?.error;
            }
            this.rootScopeService.utilityStatusClass = Constants.UTILITY_INDICATOR_COLOR.RED;
            this.isErrorMsgVisible = true;
            this.utilityError = true;
            setTimeout(() => {
              this.isErrorMsgVisible = false;
            }, 30000);
            console.log("Run Time Utility connection API failed | Error Type - " + JSON.stringify(objectError));  
            this.logService.errorLogs("Run Time Utility connection API failed | Error Type - " + JSON.stringify(objectError), this.fileName);
          }
        },
      });
  }, 500);

  }

  /**Below method open the TBAGUIApp when authentication success
     */
  // launchTBAGUIApp() {
  //   this.rootScopeService.openNewTab(TBA_LOGIN_URL);
  // }

  /**Below method check the TBA GUI health on hitting the localhost url on which contain TBA GUI port and
   * TBA GUI session and if its gets successful response the TBA indicator turns into green and in case of any error
   * the TBA indicator turns into red.*/
  getTbaHealthConnectivity() {
    // console.log('getTbaHealthConnectivity callled')
     let isPresent = localStorage.getItem('TBAGUIRegistrationnAuthorized');
    let isConnected = localStorage.getItem('isConnected');
    if (isPresent &&  isConnected) {
    
    

    this.logService.debugLogs("TBA health connection check initiated", this.fileName);
    const port = sessionStorage.getItem('tba_port');
    const sessionId = sessionStorage.getItem('tba_sessionId');
    const url = `https://localhost:${port}/health/${sessionId}`;
    
    this.http.get(url).subscribe({
      next: (res: any) => {
        if (res) {
          this.rootScopeService.tbaIndicatorClass.next(
            Constants.TBA_INDICATOR_COLOR.GREEN
          );
          this.rootScopeService.TBAGUIHealthCheckError = false;
          this.rootScopeService.TBAGUIConnected = true;
          this.logService.debugLogs("TBA health connection check successful", this.fileName);
        }

      },
      error: (err: any) => { 
        if (err) {
          this.rootScopeService.tbaIndicatorClass.next(
            Constants.TBA_INDICATOR_COLOR.RED
          );
          this.rootScopeService.TBAGUIHealthCheckError = true;
          this.rootScopeService.TBAGUIConnected = false;
          this.logService.errorLogs("TBA health connection check failed | Response Type :" + JSON.stringify(err), this.fileName);
        }
        //this.rootScopeService.captureLogsDb("TBAGUI-HEALTH-CONNECT-API-FAILURE: "+err?.error,Constants.ERROR);
      },
    });

  }
  else{

     this.logService.errorLogs("TBA connection failed | Racfpassword not present" , this.fileName);
       

  }
  }


  /**Below method start the setInterval exposed method which we implemented for 
   * TBA GUI health check in every 60 seconds(db-configurable in mili seconds).*/
  startTbaConnectivityInterval() {
    this.getTbaHealthConnectivity();
    // console.log('startTbaConnectivityInterval called');
    const intervalTime = 1 * this.rootScopeService.tbaConnectivityThreshold;
    /* istanbul ignore next */
    this.rootScopeService.tbaConnectivitySetInterval = setInterval(() => {
      this.getTbaHealthConnectivity();
    }, intervalTime);
  }

  /**Below method clear the setInterval exposed method which we started for 
   * TBA GUI health check in every 60 seconds(db-configurable).*/
  stopTbaConnectivityInterval() {
    clearInterval(this.rootScopeService.tbaConnectivitySetInterval);
  }
  /*Below method loginTBAGUIApp() login the TBAGUIWEBFRONT App by recfId and Password**/
  loginTBAGUIApp() {
    // console.log('Method loginTBAGUIApp called');
    const port = sessionStorage.getItem('tba_port');
    const sessionId = sessionStorage.getItem('tba_sessionId');
    const url = `https://localhost:${port}/login`;
    //let tbaGuiRegisterFormObj = this.rootScopeService.getValueFromSessiondb("tbaGuiRegisterFormObj", TbaRegistrationDTO)
    // let decryptRecfId = this.encrytDecryptService.decrypt(tbaGuiRegisterFormObj?.racfId);
    // let decryptRacfPassword = this.encrytDecryptService.decrypt(tbaGuiRegisterFormObj?.racfPassword);
    let payload = {
      racfId: this.rootScopeService.tbaGuiRegisterFormObj.racfId ? this.rootScopeService.tbaGuiRegisterFormObj.racfId : '',
      password: this.rootScopeService.tbaGuiRegisterFormObj.racfPassword ? this.rootScopeService.tbaGuiRegisterFormObj.racfPassword : '',
      sessionId: sessionId
    };
    // console.log('loginTBA url', url);
    let headers = new HttpHeaders()
      .append('Content-Type', 'application/json');
    this.http.post(url, payload, {
      headers: headers,
      responseType: 'text',
    }).subscribe({
      next: (data: any) => {
         /* istanbul ignore next */
        if (data?.result == 'success' || JSON.parse(data).result) {
          this.rootScopeService.TBAGUIAuthenticated = true;
          this.closeTBAWebFrontTab();
          // console.log('loginTBAGUIApp success', data?.result);
        }
      },
      error: (error) => {
        this.rootScopeService.TBAGUIAuthenticated = false;
        // console.log('Error in loginTBAGUIApp', error);
        this.logService.errorLogs("TBAGUI-LOGIN-API-FAILURE: " + JSON.stringify(error), this.fileName);
      },
    });
  }

  closeTBAWebFrontTab() {
    if (this.rootScopeService.tbawindow.has(this.rootScopeService.sessionId)) {
      let tabRef = this.rootScopeService.tbawindow.get(this.rootScopeService.sessionId);
      // if (tabRef)
      //   tabRef?.close();
    }
  }


  getUtilityHealth() {
    this.logService.debugLogs("Run Time Utility health connection check initiated", this.fileName);
    this.isErrorMsgVisible=false;
    const port = sessionStorage.getItem('tba_port');
    const sessionId = sessionStorage.getItem('tba_sessionId');
    const url = `https://localhost:${port}/health/${sessionId}`;
    this.http.get(url).subscribe({
      next: (res: any) => {
        if (res) {
          this.rootScopeService.utilityStatusClass = Constants.UTILITY_INDICATOR_COLOR.GREEN;
          this.isErrorMsgVisible=false;
          this.logService.debugLogs("Run Time Utility health connection check successful", this.fileName);
        }
      },
      error: (err: any) => {
        if (err) {
          this.rootScopeService.utilityStatusClass = Constants.UTILITY_INDICATOR_COLOR.RED;        
          this.isErrorMsgVisible = true;
          /* istanbul ignore next */
          setTimeout(() => {
            this.isErrorMsgVisible = false;
          }, 30000);

        }
        this.logService.errorLogs("Run Time Utility health connection check API failed | Response Type: " + JSON.stringify(err), this.fileName);
      },
    });
  }

  reLunchUtility(){
    this.logService.debugLogs("reLunchUtility method called for reconnection Run Time Utility ", this.fileName);
    this.rootScopeService.tbawindow.set(this.rootScopeService.sessionId, window.open(Constants.TBA_LOGIN_URL, '_self'));
    clearInterval(this.setUtilityInterval);
    this.runTimeUtilityLogin(this.rootScopeService.lanId);
    this.isErrorMsgVisible = false;
  }

/**
 * Starts a recurring timer using the backend-provided interval (in seconds).
* On each tick, fetches and resets the refresh counter and pushes it to SQS if moduleRefreshCounterMap > 0.
* Timer runs continuously at the configured interval.
* @author:HASHID
* CCR3-6969
 */
  startTimerCheckAlisRefresh(): void {
    let configTimer = this.rootScopeService.CCTConfigs.INTERACTION_REFRESH_LINK_LOGS_TIME;
   /* istanbul ignore next */
    timer(configTimer * 1000, configTimer * 1000).subscribe(() => {
      if (this.rootScopeService.hasAnyCounter()) {
        const counterMap = this.rootScopeService.getAndResetRefreshCounters();
        this.rootScopeService.alisIntractionRefreshTracToSqs(counterMap)
      }
    });
  }

}
